import { render, staticRenderFns } from "./AccordionDiagnosticosSocioambientaisCertificacao.vue?vue&type=template&id=3a5308ef&scoped=true"
import script from "./AccordionDiagnosticosSocioambientaisCertificacao.vue?vue&type=script&lang=js"
export * from "./AccordionDiagnosticosSocioambientaisCertificacao.vue?vue&type=script&lang=js"
import style0 from "./AccordionDiagnosticosSocioambientaisCertificacao.vue?vue&type=style&index=0&id=3a5308ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5308ef",
  null
  
)

export default component.exports